<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} autor
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-9">
              <div class="row">
                <div class="form-group col-lg-3">
                  <label>Nombre corto (Distintivo)<span class="required"></span></label>
                  <input type="text" id="category_description"
                    [ngClass]="{'parsley-error': (submitted && f['name'].errors)}" formControlName="name"
                    required="true" class="form-control" [autofocus]>
                  <div *ngIf="submitted && f['name'].errors">
                    <small class="text-danger" *ngIf="f['name'].errors['required']">Nombre es requerido</small>
                    <small class="text-danger" *ngIf="f['name'].errors['minlength']">Nombre Muy corto</small>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label>Nombres Completos</label>
                  <input type="text" class="form-control" formControlName="fullname">
                </div>
                <div class="form-group col-lg-3">
                  <label>N° documento</label>
                  <input type="text" class="form-control" formControlName="document">
                </div>
                <div class="form-group col-lg-3">
                  <label>Profesion</label>
                  <input type="text" class="form-control" formControlName="profession">
                </div>
                <div class="form-group col-lg-3">
                  <label>N° Celular</label>
                  <input type="text" class="form-control" formControlName="cellphone">
                </div>
                <div class="form-group col-lg-3">
                  <label>Correo electrónico</label>
                  <input type="email" class="form-control" formControlName="email">
                </div>
                <div class="form-group col-lg-12">
                  <label>Biografía</label>
                  <textarea type="text" class="form-control" formControlName="biography" rows="4"></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <p class="text-center p-t-15">
                <ng-container *ngIf="item.value.url_image != null">
                  <img width="230" height="185" src="tenants/{{item.value.url_image}}" alt="Preview">
                </ng-container>
                <ng-container *ngIf="item.value.url_image == null">
                  <ng-container *ngIf="imageUrl == null">
                    <img id="output" width="200" src="/images/default.png" />
                  </ng-container>
                  <ng-container *ngIf="imageUrl != null">
                    <img width="230" height="185" [src]="imageUrl" alt="Preview">
                  </ng-container>
                </ng-container>
              </p>
              <p class="text-center">
                <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                  Seleccionar imagen
                    <input id="file" type="file" accept=".png, .jpg, .jpeg" style="visibility: hidden;"
                    (change)="onFileSelectedShowCrop($event)">
                </label>
              </p>
            </div>

            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- sample modal content -->
  <div id="modalCroppedCover" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0">Recortar imagen</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="imageCoverChangedEvent" style="width: 70%;">
            <image-cropper [imageChangedEvent]="imageCoverChangedEvent" [maintainAspectRatio]="true"
              [aspectRatio]="4 / 3" [resizeToWidth]="1000" format="jpeg" (imageCropped)="imageCroppedCover($event)">
            </image-cropper>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" (click)="confirmCrop()">Seleccionar imagen</button>
        </div>
      </div>
    </div>
  </div>
</div>
